import { TBtcWalletId } from 'modules/api';
import { useCallback } from 'react';
import { useConnectBtcMutation } from '../actions/connectBtc';
import { useDisconnectBtcMutation } from '../actions/disconnectBtc';
import { BTC_CONNECTION_CACHE_KEY } from '../const';

export interface IBtcConnectionData {
  address?: string;
  isConnected: boolean;
  isLoading: boolean;
  walletId?: TBtcWalletId;
  connect: (providerId?: TBtcWalletId) => void;
  disconnect: () => void;
}

export function useBtcConnection(): IBtcConnectionData {
  const [connect, { data, isLoading }] = useConnectBtcMutation({
    fixedCacheKey: BTC_CONNECTION_CACHE_KEY,
  });

  const { address, isActive: isConnected = false, walletId } = data ?? {};

  const [disconnect] = useDisconnectBtcMutation({
    fixedCacheKey: BTC_CONNECTION_CACHE_KEY,
  });

  const handleDisconnect = useCallback(() => {
    if (!walletId) return;

    const result = disconnect(walletId);
    result.reset();
  }, [disconnect, walletId]);

  const connectCallback = async (
    connectArgs: Parameters<typeof connect>[0],
  ) => {
    try {
      const result = await connect(connectArgs);
      if (!('data' in result)) return;

      if (!result.data?.walletId) return;
    } catch (error) {
      console.error(error);
    }
  };

  return {
    address,
    isConnected,
    isLoading,
    walletId,
    connect: connectCallback,
    disconnect: handleDisconnect,
  };
}
